import { TemplateConfig } from "../drawer/types";
import { MM_TO_PX } from "./mapPublishedFormat";
import { RuntimeFormatConfig } from "./types";

const LEGACY_BLEED_ZONE_MM = 5;
const LEGACY_SAFETY_ZONE_MM = 3.2;
const LEGACY_EXPORT_BLEED_PX = 9;
// The export path always used this finer px/mm; kept byte-identical for legacy codes.
const LEGACY_EXPORT_PX_PER_MM = 3.7795275591;

const isPerSide = (config?: TemplateConfig | null): config is RuntimeFormatConfig =>
  !!config && "perSideBleed" in config && (config as RuntimeFormatConfig).perSideBleed;

// snapshotBaseFormat treats these as the total across both sides (it offsets by half), so per-side catalogue
// values are doubled; legacy formats keep today's shared 5 mm / 3.2 mm.
export function getZoneSizesPx(config?: TemplateConfig | null): { safetyZonePx: number; bleedsZonePx: number } {
  if (isPerSide(config)) {
    return { safetyZonePx: 2 * config.safeAreaMm * MM_TO_PX, bleedsZonePx: 2 * config.bleedMm * MM_TO_PX };
  }
  return { safetyZonePx: LEGACY_SAFETY_ZONE_MM * MM_TO_PX, bleedsZonePx: LEGACY_BLEED_ZONE_MM * MM_TO_PX };
}

// Margin the HTML export leaves around each page for the bleed.
export function getExportBleedPx(config?: TemplateConfig | null): number {
  return isPerSide(config) ? Math.round(config.bleedMm * MM_TO_PX) : LEGACY_EXPORT_BLEED_PX;
}

// Total bleed zone used to place the black line in the export's default canvas positions.
export function getExportBleedZonePx(config?: TemplateConfig | null): number {
  return isPerSide(config) ? getZoneSizesPx(config).bleedsZonePx : LEGACY_BLEED_ZONE_MM * LEGACY_EXPORT_PX_PER_MM;
}
